module.exports = __webpack_public_path__ + "img/astana2.542aac26.jpg";